// extracted by mini-css-extract-plugin
export var alignCenter = "_86-d";
export var bannerShown = "_86-6";
export var buttonContent = "_86-0";
export var cardList = "_86-1";
export var centerContent = "_86-2";
export var chevron = "_86-3";
export var closePanelButton = "_86-k";
export var conversationContextContainer = "_86-l";
export var conversationDetailContainer = "_86-4";
export var detailWrapper = "_86-7";
export var dropdownButton = "_86-e";
export var dropdownTitle = "_86-9";
export var fullHeight = "_86-5";
export var hidden = "_86-a";
export var icon = "_86-b";
export var mergeSuggestionWrapper = "_86-m";
export var panel = "_86-i";
export var portalButtonsWrapper = "_86-c";
export var right = "_86-j";
export var tableSummaryContainer = "_86-8";
export var tableSummaryHeader = "_86-g";
export var threeDotsButton = "_86-f";
export var wide = "_86-h";